import {useState, useCallback, useEffect} from 'react'
import {deleteCookies, getLocalStorageItem, setLocalStorageItem} from "../functions"

export const useAuth = () => {
    const [superUser, setSuperUser] = useState(null)
    const [rootFolder, setRootFolder] = useState(null)
    const [avatarLink, setAvatarLink] = useState(null)
    const [accessToken, setAccessToken] = useState(null)
    const [refreshToken, setRefreshToken] = useState(null)
    const [nickName, setNickName] = useState(null)
    const [language, setLanguage] = useState(null)
    const [ready, setReady] = useState(false)
    const [userId, setUserId] = useState(null)
    const [authenticatedVia, setAuthenticatedVia] = useState(null)
    const [deviceId, setDeviceId] = useState(null)
    const [email, setEmail] = useState(null)

    const login = useCallback(
        (superUser,
         rootFolder,
         avatarLink,
         jwtAccessToken,
         jwtRefreshToken,
         id, nick, lang,
         authenticatedVia,
         deviceId, email, googleAccountIndex) => {

            setSuperUser(superUser)
            setRootFolder(rootFolder)
            setAvatarLink(avatarLink)
            setAccessToken(jwtAccessToken)
            setRefreshToken(jwtRefreshToken)
            setUserId(id)
            setEmail(email)
            setNickName(nick)
            setLanguage(lang)
            setAuthenticatedVia(authenticatedVia)
            if (!deviceId) {
                deviceId = crypto.randomUUID()
            }
            setDeviceId(deviceId)
            setLocalStorageItem('userData', {
                superUser: superUser,
                rootFolder: rootFolder,
                avatarLink: avatarLink,
                userId: id,
                accessToken: jwtAccessToken,
                refreshToken: jwtRefreshToken,
                nickName: nick,
                language: lang,
                authenticatedVia: authenticatedVia,
                deviceId: deviceId,
                email: email,
                googleAccountIndex: googleAccountIndex
            })
        }, [])


    const logout = useCallback(() => {
        setSuperUser(null)
        setRootFolder(null)
        setAvatarLink(null)
        setAccessToken(null)
        setRefreshToken(null)
        setUserId(null)
        setNickName(null)
        setLanguage(null)
        setAuthenticatedVia(null)
        setDeviceId(null)
        setEmail(null)
        deleteCookies()
    }, [])

    useEffect(() => {
        const data = getLocalStorageItem('userData')

        if (data && data.accessToken) {
            login(
                data.superUser,
                data.rootFolder,
                data.avatarLink,
                data.accessToken,
                data.refreshToken,
                data.userId,
                data.nickName,
                data.language,
                data.authenticatedVia,
                data.deviceId,
                data.email,
            )
        }
        setReady(true)
    }, [login])

    return {
        superUser,
        login,
        logout,
        rootFolder,
        avatarLink,
        accessToken,
        refreshToken,
        userId,
        ready,
        nickName,
        language,
        authenticatedVia,
        deviceId,
        email
    }
}
